import { useMemo } from 'react';
import get from 'lodash/get';
import { useAppSelector } from '../../../hooks/useAppStore';
import { getAuthenticateUser } from '../../../store/authenticate/selectors';
import { getManagerPermissions } from '../../../store/settings/selectors';
import { usePermissions } from '../../../hooks/useCommon';

export function useCommissionPlansPermissions() {
  const { personnel } = useAppSelector(getAuthenticateUser);
  const settings = useAppSelector(getManagerPermissions);
  const { permissions: localPermissions } = usePermissions();

  const commissionPlansPermissions = useMemo(() => {
    const isManager = personnel.permissionLevel === 'Manager';

    // Commission Plans permissions
    const canManageCommissionPlans = get(settings, 'actions.commissionPlans.manage');
    const canViewCommissionPlans = get(settings, 'visibility.commissionPlans.view');

    return {
      isAllowManage: localPermissions.isAdmin || (isManager && canViewCommissionPlans && canManageCommissionPlans), // Managers need both view + manage permissions for commission plans
      isAllowViewCommissionPlans: localPermissions.isAdmin || (isManager && canViewCommissionPlans), // Managers need the visibility permission to view commission plans
    };
  }, [personnel.permissionLevel, settings, localPermissions]);

  return {
    commissionPlansPermissions,
  };
}
